import React from "react";

const Floater = () => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!show) return null;
  return (
    <div className="fixed bottom-6 right-24 z-20">
      <button
        className="flex h-14 w-14 items-center justify-center rounded-full border border-white/15 bg-white/10 shadow-glass backdrop-blur-xl"
        title="Go to top"
      >
        <img
          src="images/icons/up.png"
          width="32px"
          height="32px"
          className="rotate-0"
          alt=""
          onClick={() => {
            const target = document.getElementById("main-content");
            if (target) {
              const yOffset = -200;
              const y =
                target.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
              window.scrollTo({ top: y, behavior: "smooth" });
            }
          }}
        />
      </button>
    </div>
  );
};

export default Floater;
